import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
// Lazy-load secondary pages so the homepage ships less JS
const AboutPage = lazy(() => import('./pages/AboutPage').then(m => ({
  default: m.AboutPage
})));
const ProgramsPage = lazy(() => import('./pages/ProgramsPage').then(m => ({
  default: m.ProgramsPage
})));
const ImpactPage = lazy(() => import('./pages/ImpactPage').then(m => ({
  default: m.ImpactPage
})));
const ArticlesPage = lazy(() => import('./pages/ArticlesPage').then(m => ({
  default: m.ArticlesPage
})));
const ArticleDetailPage = lazy(() => import('./pages/ArticleDetailPage').then(m => ({
  default: m.ArticleDetailPage
})));
const TestimonyDetailPage = lazy(() => import('./pages/TestimonyDetailPage').then(m => ({
  default: m.TestimonyDetailPage
})));
const TeamPage = lazy(() => import('./pages/TeamPage').then(m => ({
  default: m.TeamPage
})));
const JourneyPage = lazy(() => import('./pages/JourneyPage').then(m => ({
  default: m.JourneyPage
})));
const GalleryPage = lazy(() => import('./pages/GalleryPage').then(m => ({
  default: m.GalleryPage
})));
function PageFallback() {
  return <div className="min-h-[60vh] flex items-center justify-center pt-20" data-id="element-0">
      <div className="w-8 h-8 border-2 border-gold/30 border-t-gold rounded-full animate-spin" data-id="element-1" />
    </div>;
}
export function App() {
  return <Router data-id="element-2">
      <ScrollToTop data-id="element-3" />
      <div className="min-h-screen flex flex-col w-full" data-id="element-4">
        <Navigation data-id="element-5" />
        <Suspense fallback={<PageFallback data-id="element-7" />} data-id="element-6">
          <Routes data-id="element-8">
            <Route path="/" element={<Home data-id="element-10" />} data-id="element-9" />
            <Route path="/about" element={<AboutPage data-id="element-12" />} data-id="element-11" />
            <Route path="/programs" element={<ProgramsPage data-id="element-14" />} data-id="element-13" />
            <Route path="/impact" element={<ImpactPage data-id="element-16" />} data-id="element-15" />
            <Route path="/team" element={<TeamPage data-id="element-18" />} data-id="element-17" />
            <Route path="/journey" element={<JourneyPage data-id="element-20" />} data-id="element-19" />
            <Route path="/gallery" element={<GalleryPage data-id="element-22" />} data-id="element-21" />
            <Route path="/articles" element={<ArticlesPage data-id="element-24" />} data-id="element-23" />
            <Route path="/articles/:slug" element={<ArticleDetailPage data-id="element-26" />} data-id="element-25" />
            <Route path="/testimonies/:slug" element={<TestimonyDetailPage data-id="element-28" />} data-id="element-27" />
          </Routes>
        </Suspense>
        <Footer data-id="element-29" />
      </div>
    </Router>;
}